import React from 'react';
import { Box } from '@mui/material';
import { useFavorites } from '../context/FavoritesContext';

const HEART_PATH =
  'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z';

function HeartIcon({ fill, stroke, size = '1.5rem' }) {
  return (
    <Box
      component="svg"
      viewBox="0 0 24 24"
      sx={{ width: size, height: size, display: 'block' }}
      aria-hidden
    >
      <path
        d={HEART_PATH}
        fill={fill}
        stroke={stroke}
        strokeWidth="1.25"
        vectorEffect="non-scaling-stroke"
      />
    </Box>
  );
}

const overlaySx = {
  position: 'absolute',
  bottom: 8,
  left: 8,
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  lineHeight: 0,
};

const inlineSx = {
  position: 'static',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  marginTop: '-1px',
  border: 'none',
  background: 'none',
  cursor: 'pointer',
  lineHeight: 0,
};

const TOGGLE_BY_TYPE = {
  item: 'toggleItem',
  product: 'toggleProduct',
  tour: 'toggleTour',
  service: 'toggleService',
};

const IS_FAVORITE_BY_TYPE = {
  item: 'isItemFavorite',
  product: 'isProductFavorite',
  tour: 'isTourFavorite',
  service: 'isServiceFavorite',
};

export default function FavoriteButton({ type = 'item', entityId, inline = false, sx = {} }) {
  const favorites = useFavorites();
  const isFavoriteFn = favorites[IS_FAVORITE_BY_TYPE[type]] || favorites.isItemFavorite;
  const toggleFn = favorites[TOGGLE_BY_TYPE[type]] || favorites.toggleItem;
  const active = isFavoriteFn(entityId);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleFn(entityId);
  };

  const heartFill = active ? '#d32f2f' : inline ? 'transparent' : '#fff';
  const heartStroke = active ? '#d32f2f' : inline ? '#9e9e9e' : '#000';
  const heartSize = inline ? '1.2rem' : '1.5rem';

  return (
    <Box
      component="button"
      type="button"
      onClick={handleClick}
      sx={{ ...(inline ? inlineSx : overlaySx), ...sx }}
      aria-label={active ? 'Убрать из избранного' : 'Добавить в избранное'}
    >
      <HeartIcon fill={heartFill} stroke={heartStroke} size={heartSize} />
    </Box>
  );
}
